import { render, staticRenderFns } from "./roomNumberDia.vue?vue&type=template&id=38416258&"
import script from "./roomNumberDia.vue?vue&type=script&lang=js&"
export * from "./roomNumberDia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports